import { EOfferStatusData, TOfferFromHistoryData } from '../../types';

export const useDeactivatedLabelTitle = (offerFromHistory: TOfferFromHistoryData | null): string | null => {
  if (offerFromHistory?.status === EOfferStatusData.Deactivated) {
    return 'Снято с публикации';
  }

  return null;
};
